module.exports = __webpack_public_path__ + "static/media/team.99158cc5.webp";